import * as React from "react";
import Box from "@mui/material/Box";
import {
  FormControl,
  Grid,
  TextField,
  Tooltip,
  IconButton,
  Button,
  Drawer,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState } from "react";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import { postJsonData } from "../network/ApiController";
import { whiteColor } from "../theme/setThemeColor";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const AddNews = ({ refresh }) => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState(false);

  const schema = Yup.object().shape({
    role: Yup.string().required("Role is required"),
    news: Yup.string().required("News is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    reset()
    if (refresh) refresh();
  };

  const onSubmit = (data) => {
    setRequest(true);
    postJsonData(
      ApiEndpoints.GET_NEWS,
      data,
      setRequest,
      (res) => {
        okSuccessToast("News added successfully");
        handleClose();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      <Tooltip title="Add news">
        <Button
          variant="outlined"
          className="refresh-icon-risk"
          onClick={handleOpen}
          startIcon={
            <IconButton sx={{ p: 0, color: whiteColor() }}>
              <AddCircleOutlineIcon />
            </IconButton>
          }
          sx={{ py: 0.3 }}
        >
          Add News
        </Button>
      </Tooltip>

      <Drawer open={open} anchor="right" onClose={handleClose}>
        <Box sx={{ width: 400 }}>
          <ModalHeader
            title="Add news"
            handleClose={handleClose}
            subtitle="Easily Add New News with DilliPay"
          />
          <Box
            component="form"
            id="addAcc"
            autoComplete="off"
            onSubmit={handleSubmit(onSubmit)}
            sx={{ "& .MuiTextField-root": { m: 1 } }}
          >
            <Grid container sx={{ pt: 1 }}>
              <Grid item xs={12}>
                {/* Static Role Dropdown */}
                <FormControl sx={{ width: "100%" }}>
                  <Controller
                    name="role"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Select Role"
                        size="small"
                        error={!!errors.role}
                        helperText={errors.role?.message}
                      >
                        <MenuItem value="Api">Api</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </TextField>
                    )}
                  />
                </FormControl>

                {/* News Input */}
                <FormControl sx={{ width: "100%" }}>
                  <Controller
                    name="news"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        autoComplete="off"
                        label="Enter your news"
                        id="news"
                        size="small"
                        required
                        error={!!errors.news}
                        helperText={errors.news?.message}
                        inputProps={{ maxLength: 100 }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^a-zA-Z0-9\s.,!?]/g,
                            ""
                          );
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Box sx={{ mr: "5px" }}>
              <ModalFooter form="addAcc" request={request} />
            </Box>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AddNews;
